import store from 'Store'
import Nprogress from 'nprogress'
// helpers
import { networkErrorPage } from '../helpers'
import { Notification } from 'Utils/Classes/Notification'

// Preparing notifiaction
const notification = new Notification()
notification.message = 'Ha habido un error con el servidor'

export const loadCards = async (from, next) => {
  // is user navigating trough same parent? ⤵
  const isDashboardRelated = from.matched.some((match) => match.path.includes('dashboard'))
  // checking if cards are already loaded
  if (store.state.cards.userCards && isDashboardRelated) return next()

  Nprogress.start()
  try {
    const cards = await store.dispatch('cards/getCards')
    if (!cards.data) throw cards
    Nprogress.done()
    return next()
  } catch (error) {
    Nprogress.done()
    // assuming network error
    if (!error.response) {
      return next(networkErrorPage)
    }
    next({ name: 'dashboard' })
    notification.dispatch()
  }
}
